export default __webpack_public_path__ + "static/step-two-both-do-582605997901a49f0b5b5e3ff28ffdd3.png";